import { Fragment, createElement } from 'react';
import rehypeParse from 'rehype-parse';
import rehypeReact from 'rehype-react';
import rehypeSanitize from 'rehype-sanitize';
import { unified } from 'unified';
import { getSearchHighlightContext } from './getSearchHighlightContext';
import { Mark } from './styled';
/**
 * Safely renders HTML text from search results with highlighted matches.
 *
 * @example
 * // Input: '<mark>contract</mark> management <script>alert("xss")</script>'
 * // Output: Renders "<mark>contract</mark> management" with "contract" highlighted (script removed)
 */
export function useSafeSearchResultText(props) {
    const { name, highlight } = props;
    const { highlightText, showNameOnly } = getSearchHighlightContext(name, highlight);
    const sanitize = () => rehypeSanitize({
        tagNames: ['mark'],
    });
    const { result } = unified()
        .use(rehypeParse, { fragment: true })
        .use(sanitize)
        .use(rehypeReact, {
        Fragment,
        createElement,
        components: {
            mark: Mark,
        },
    })
        .processSync(highlightText);
    return {
        showNameOnly,
        result,
    };
}
